import styled from "styled-components";

export const AboutUsContainer = styled.div`
    color: #fff;
    background: #f9f9f9;
    padding-top: ${({topMargin}) => (topMargin ? '100px' : '0px')};
    position: ${({pdf}) => (pdf ? 'relative' : 'static')};
    min-height: ${({pdf}) => (pdf ? '100vh' : 'auto')};
    display: ${({pdf}) => (pdf ? 'flex' : 'block')};
    flex-direction: column;

    @media screen and (max-width: 768px) {
        padding: 0;
        padding-top: 100px;
    }
`

export const AboutUsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    width: 100%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding: 40px 24px;
    flex-grow: ${({pdf}) => (pdf ? 1 : 0)};
    
    @media screen and (max-width: 768px) {
        padding: 20px 16px;
    }
`

export const AboutUsRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: ${({pdf}) => (pdf ? 'stretch' : 'center')};
    grid-template-areas: 'col2';
    width: 100%;
    height: 100%;

    @media screen and (max-width: 768px) {
        grid-template-areas: 'col2';
    }
`

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`

export const Column2 = styled.div`
    margin-bottom: ${({pdf}) => (pdf ? '0' : '15px')};
    padding: 0;
    grid-area: col2;
    width: 100%;
    height: ${({pdf}) => (pdf ? '100%' : 'auto')};
`

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`

export const TopLine = styled.p`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`

export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: ${({darkText}) => (darkText ? '#010606' : '#fff')};
`

export const BtnWrap = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
    gap: 16px;
    
    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }
`

export const ImgWrap = styled.div`
    max-width: 100%;
    height: 100%;
    display: ${({imgDisplay}) => (imgDisplay ? 'block' : 'none')};
    margin: 40px auto;
    text-align: center;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
`

export const ImgWrap2 = styled.div`
    max-width: 100%;
    height: 100%;
    display: ${({imgDisplay2}) => (imgDisplay2 ? 'block' : 'none')};
    padding-top: ${({topMargin2}) => (topMargin2 ? '100px' : '0px')};
    margin: 40px auto;
    text-align: center;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
`

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`;

export const AboutUsH1 = styled.h1`
    font-size: 2.5rem;
    color: #2d3748;
    margin-bottom: 48px;
    text-align: center;
    font-weight: 700;
    letter-spacing: -0.025em;
    line-height: 1.2;

    @media screen and (max-width: 768px) {
        font-size: 2rem;
        margin-bottom: 32px;
    }
    
    @media screen and (max-width: 480px) {
        font-size: 1.8rem;
        margin-bottom: 24px;
    }
`;

export const AboutUsP = styled.p`
    max-width: 900px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 28px;
    color: #2d3748;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 0 20px;
    
    @media screen and (max-width: 768px) {
        font-size: 16px;
        line-height: 26px;
        padding: 0 10px;
    }
`;

export const AboutUsP2 = styled.p`
    max-width: 900px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 28px;
    color: #2d3748;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 0 20px;
    
    @media screen and (max-width: 768px) {
        font-size: 16px;
        line-height: 26px;
        padding: 0 10px;
    }
`;

export const AboutUsP3 = styled.p`
    max-width: 900px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 28px;
    color: #2d3748;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 0 20px;
    
    @media screen and (max-width: 768px) {
        font-size: 16px;
        line-height: 26px;
        padding: 0 10px;
    }
`;

export const Iframe = styled.iframe`
    width: 100%;
    height: 100%;
    display: ${({iframeDisplay}) => (iframeDisplay ? 'block' : 'none')};
`;

export const Image = styled.img`
    width: 100%;
    max-width: 800px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    
    &:hover {
        transform: scale(1.02);
    }
`;

export const SectionDivider = styled.div`
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #38A7BA, #2E8A99);
    margin: 40px auto;
    border-radius: 2px;
    
    @media screen and (max-width: 768px) {
        width: 60px;
        margin: 30px auto;
    }
`;